import { CompatApp } from './compat'

export const getApp = (): CompatApp =>
  ((global as unknown) as { app: CompatApp }).app
